import angular from 'angular';

import LandingComponent from './landing.cmpt';

export default angular
    .module('presentation.scene.landing', [])
    .component(LandingComponent.selector, LandingComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('landing', {
        url: '/',
        template: '<db-p-landing></db-p-landing>'
    });
}



// WEBPACK FOOTER //
// ./src/presentation/scene/landing/index.js